import React, { useState, useEffect, useRef } from 'react';
import {
  StepInlineWrapper,
  StepLine,
  StepNumber,
  StepTitle,
  StepWrapper,
  TextWrapper,
} from './StepHorizontal.styles';
import { BodyText } from '../../../../atoms';

interface StepProps {
  isActive: boolean;
  isCompleted: boolean;
  stepCount: number;
  title: string;
}
const StepHorizontal = ({
  stepCount,
  title,
  isActive,
  isCompleted,
}: StepProps) => {
  const stepState = isActive
    ? 'active'
    : isCompleted
    ? 'completed'
    : 'disabled';
  const stepLineColor = isActive || isCompleted ? 'completed' : 'disabled';
  const [width, setWidth] = useState(0);
  const wrapperRef = useRef<HTMLDivElement>();

  useEffect(() => {
    if (wrapperRef?.current) {
      setWidth(0.5 * wrapperRef.current.getBoundingClientRect().width);
    }
  }, [wrapperRef]);

  return (
    <StepWrapper gridGap={5} ref={wrapperRef}>
      <StepLine color={stepLineColor} lineSize={'regular'} />
      <StepInlineWrapper>
        <StepNumber size={'regular'} color={stepState}>
          {stepCount}
        </StepNumber>
        <StepTitle text={stepState}>
          <BodyText variant={'body2'} color={'inherit'} fontWeight={2}>
            <TextWrapper width={width}>{title}</TextWrapper>
          </BodyText>
        </StepTitle>
      </StepInlineWrapper>
      <StepLine
        color={isCompleted ? 'completed' : 'disabled'}
        lineSize={'regular'}
      />
    </StepWrapper>
  );
};
export default StepHorizontal;
